import { SystemPermissionDef } from '@juvare/contact-management/backend/features/permissions/shared';

const groupName = 'Account';

export const backgroundCheckSystemPermissions = {
    'request-background-check': {
        group: groupName,
        label: 'Request Background Check',
    },
    'manage-background-check-data': {
        group: groupName,
        label: 'Manage Background Check Data',
    },
    'view-full-background-check-history': {
        group: groupName,
        label: 'View Full Background Check Data',
    },
    'view-partial-background-check-history': {
        group: groupName,
        label: 'View Partial Background Check Data',
    },
} as const satisfies SystemPermissionDef;
